import React from 'react'
import { Dialog } from '@material-ui/core'
import { GetSamplePostResponse } from 'apis/door/PostV1'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import SamplePostDetail from '../post/SamplePostDetail'
import SamplePostOwnerDetail from 'components/door/post/SamplePostOwnerDetail'

interface Props {
  doorID: string
  open: boolean
  onClose: Function
  samplePost: GetSamplePostResponse | undefined
  onSubmit: Function
}

export default function SamplePreviewDialog({
  doorID,
  open,
  onClose,
  samplePost,
  onSubmit
}: Props) {
  return (
    <StyledDialog
      open={open}
      onClose={() => {
        onClose()
      }}
      fullScreen
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <ContentWrapDiv>
        <div className="layout-col2">
          <div className="layout-col2-left">
            <SamplePostDetail
              samplePost={samplePost}
              mediaClass={[]}
              isPreview={true}
            />
          </div>
          <OwnerDetailWrap>
            <SamplePostOwnerDetail
              ownerName={samplePost?.owner.name || ''}
              ownerIcon={samplePost?.owner.icon || ''}
              description={samplePost?.door.description || ''}
              doorId={doorID}
              children={
                <OtherSamplesListWrap>
                  <OtherSamplesListTitle>投稿サンプル一覧</OtherSamplesListTitle>
                  <OtherSamplesList>
                    {samplePost &&
                      samplePost.other_sample_posts.map((post) => {
                        return (
                          <li>
                            <Link to={`/door/${doorID}/samples/${post.id}`}>
                              {post.title}
                            </Link>
                          </li>
                        )
                      })}
                    <OtherSamplesPrev>
                      <Link to={`/door/${doorID}?tab=samples`}>一覧に戻る</Link>
                    </OtherSamplesPrev>
                  </OtherSamplesList>
                </OtherSamplesListWrap>
              }
              isPreview={true}
            />
          </OwnerDetailWrap>
        </div>
      </ContentWrapDiv>
      <FooterBtnWrap>
        <FooterBtnWrapInner>
          <button
            className="btn btn-border"
            style={{
              width: '48%',
              marginTop: '0px',
              padding: '0 8px',
              maxWidth: '240px',
              color: '#707070',
              border: '1px solid #707070'
            }}
            onClick={() => {
              onClose()
            }}
          >
            戻る
          </button>
          <button
            className="btn"
            style={{
              width: '48%',
              marginTop: '0px',
              padding: '0 8px',
              maxWidth: '240px'
            }}
            onClick={() => {
              onSubmit()
            }}
          >
            登録する
          </button>
        </FooterBtnWrapInner>
      </FooterBtnWrap>
    </StyledDialog>
  )
}

const StyledDialog = styled(Dialog)`
  max-width: 1280px;
  width: 95vw;
  max-height: calc(90vh - 96px);
  margin: auto;
  left: 0 !important;
  right: 0 !important;
  top: -96px !important;
  bottom: 0 !important;
  @media (max-width: 640px) {
    max-width: 92vw;
    max-height: calc(95svh - 80px);
    top: -80px !important;
  }
`

const OwnerDetailWrap = styled.div`
  @media (max-width: 640px) {
    width: 100%;
  }
  section {
    margin-top: 0;
  }
`

const FooterBtnWrap = styled.div`
  box-shadow: 0 -3px 8px rgb(0 0 0 / 5%);
  background-color: #fff;
  z-index: 1000;
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 24px;
  @media (max-width: 640px) {
    padding: 20px 12px;
    margin: auto;
  }
`
const FooterBtnWrapInner = styled.div`
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  @media (max-width: 640px) {
    max-width: none;
  }
`

const ContentWrapDiv = styled.div`
  padding: 40px;
  @media (max-width: 640px) {
    padding: 0 16px 64px;
  }
  .layout-col2 {
    display: flex;
    justify-content: space-between;
    max-width: 1280px;
    margin: auto;
    gap: 40px;
    flex-wrap: wrap;
    @media (max-width: 768px) {
      gap: 32px;
      padding-bottom: 24px;
    }
  }

  .layout-col2-left {
    width: 69%;
    width: calc(100% - 396px);
    @media (max-width: 1280px) {
      width: calc(100% - 320px);
    }
    @media (max-width: 768px) {
      width: 100%;
    }
    .breadcrumbs .inner {
      margin: 0;
    }
  }
`

const OtherSamplesListWrap = styled.div`
  margin-top: 48px;
`
const OtherSamplesListTitle = styled.h3`
  color: #333333;
  font-size: 16px;
  font-weight: bold;
  border-bottom: 1px solid #ddd;
  padding-bottom: 8px;
  margin-bottom: 16px;
`
const OtherSamplesList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 12px;
  a {
    color: #333333;
    &:hover {
      opacity: 0.9;
    }
  }
`
const OtherSamplesPrev = styled.li`
  text-align: right;
  a {
    color: #45b5f5;
  }
`
